



























import { filterMixin } from '@/utils/mixins/filterMixin'
import Autocomplete from '@/components/Autocomplete.vue'
import { getRegions } from '@/api/Address/address'
import { Params } from '@/utils/interfaces'
import { DeliveryCurrenciesEnum } from '~/utils/interfaces/remittance.interface'
import { getMessengers } from '~/api/Remittances/remittances.api'
import FlatFilter from '~/components/FlatFilter.vue'

export default filterMixin.extend({
  components: {
    appAutocomplete: Autocomplete,
    FlatFilter,
  },
  data() {
    return {
      getRegions: (params?: Params) =>
        getRegions({ ...params, country__name: 'Cuba', limit: 20 }),
      deliveryCurrencies: Object.values(DeliveryCurrenciesEnum),
      getMessengers,
    }
  },
})
